<template>
  <div>
    <!-- <ion-header>
      <ion-toolbar class="rc-tool-bar">
        <ion-title>{{ title }}</ion-title>
      </ion-toolbar>
    </ion-header> -->
    <ion-content class="ion-padding stop-repeating-content">
      <div class="page">
        <ion-grid>
          <ion-row>
            <ion-col class="section-desc-header">
              <p>{{ title }}</p>
            </ion-col>
          </ion-row>
            <ion-row class="row-divider"></ion-row>
            <ion-row class="rectangle">
              <ion-col>
                <ion-row align-items-stretch>
                <ion-col size="9" class="col-padding">
                  <ion-label class="book-station">{{reservation.station.name}}<span v-if="reservation.station.rating != 0">&nbsp;{{reservation.station.rating}}&nbsp;<ion-icon class="star-rating" :icon="star"></ion-icon></span></ion-label>
                  <br />
                  <ion-label
                    class="reservation-desc"
                  >{{reservation.station.address.line1}}, {{reservation.station.address.city}}</ion-label>
                  <br />
                  <br />
                  <ion-label class="section-desc">
                    {{reservation.station.address.line1}},
                    {{reservation.station.address.line2}}
                    <br />
                    {{reservation.station.address.line3}},
                    {{reservation.station.address.city}}
                    <br />
                    {{reservation.station.address.state.name}} -
                    {{reservation.station.address.zipcode}}
                  </ion-label>
                </ion-col>

                  <ion-col>
                      <label class="section-desc-rating" size="12" size-md="12" style="white-space:nowrap;"> 
                    Your rating
                    
                    <!-- <star-rating 
                        @rating-selected ="setRating"
                        v-bind:show-rating="false"
                        v-bind:max-rating="5"
                        active-color="#21b24b"
                        v-bind:star-size="25">
                      </star-rating> -->
                      </label>
                      <star-rating active-color="#21b24b" @update:rating ="setRating" :star-size="25" :show-rating="false"></star-rating>
                  </ion-col>
                </ion-row>
              </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-button class="btn-primary" expand="block" @click="this.processSubmit">Submit</ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>      
      </div>
    </ion-content>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonHeader, IonToolbar, IonContent, IonTitle, IonGrid, IonRow, IonCol, IonLabel, IonButton, modalController } from "@ionic/vue";

import StarRating from 'vue-star-rating';
import { star } from "ionicons/icons"

export default defineComponent ({
  name: 'ReservationRatingModal',
  components: {
    IonHeader, IonToolbar, IonContent, IonTitle, IonGrid, IonRow, IonCol, IonLabel, IonButton, StarRating, modalController
  },
  props: {
    title: { type: String, default: 'Reservation Rating' },
    reservation: { type: Object },
  },
  async mounted() {
    // alert("Mounted")
  },
  data() {
    return {
      star,
      content: 'This is a sample Modal',
      rating : 0
    }
  },
  methods:{
    setRating: function(rating){
      this.rating= rating;
    },
    processSubmit: function(){
      // this.rateReservationStation(this.rating);
      modalController.dismiss(this.rating)
    }
  }
})
</script>

<style scoped>
.rc-tool-bar{
  background-color: blue;
}
.stop-repeating-content {
  position: absolute;
  /* height: 450px; */
}
.section-desc-header {
    text-align: left;
    font-family: "Roboto";
    font-size: 18px;
    letter-spacing: 0;
    color: #000000;
    opacity: 0.76;
}
</style>